import React from 'react';
import SEO from '../../../component/common/SEO';
import { pageSEO } from '../../../config/seoConfig';
import './style.css';

export default function ReturnAndRefundPolicy() {
  return (
    <div className="return_policy_bg">
      <SEO {...pageSEO.returnRefund} />
      {/* Banner */}
      <div className="return_policy_banner"></div>

      <div className="return_policy_content">
        <section className="return_policy_delevery">
          <h1>Refund Policy</h1>
          <p>
            At <strong>Importerr.com</strong>, a brand owned by <strong>Boundless Trends Pvt. Ltd.</strong>, we aim to provide the best quality goods in bulk across India. Since we operate as a <strong>B2B wholesale supplier</strong>, refunds are handled carefully under specific conditions outlined below.
          </p>
        </section>

        <section className="refund_return_policy">
          <h2>1. Eligibility for Refund</h2>
          <p>Refunds will be issued only in the following cases:</p>
          <ul>
            <li>The product delivered is <strong>damaged during transit</strong>.</li>
            <li>The <strong>wrong product</strong> has been delivered compared to the confirmed order.</li>
          </ul>
        </section>

        <section className="refund_return_policy">
          <h2>2. Non-Refundable Cases</h2>
          <ul>
            <li>Refunds are <strong>not applicable</strong> for bulk orders once the customer has approved demo samples.</li>
            <li>Returns and refunds will <strong>not</strong> be processed for reasons such as change of mind, over-ordering, or after products have been used.</li>
            <li>Minor variations in product color, design, or packaging that do not affect the quality or usability are not eligible for refund.</li>
          </ul>
        </section>

        <section className="refund_return_policy">
          <h2>3. Reporting Damaged or Wrong Products</h2>
          <ul>
            <li>Customers must notify us within <strong>48 hours of delivery</strong> in case of damaged or incorrect products.</li>
            <li>Clear photo/video evidence must be provided for verification.</li>
            <li>Claims made after 48 hours will not be entertained.</li>
          </ul>
        </section>

        <section className="refund_return_policy">
          <h2>4. Refund Process</h2>
          <ul>
            <li>Once the claim is verified and approved, we will initiate a <strong>replacement or refund</strong> as per customer preference.</li>
            <li>Refunds will be processed immediately and reflects to the original payment method within <strong>7–10 business days</strong> after approval.</li>
          </ul>
        </section>

        <section className="refund_return_policy">
          <h2>5. Refund Options</h2>
          <p>Customers can choose one of the following refund methods:</p>
          <ul>
            <li>Refund to original payment method (processed within 7–10 business days)</li>
            <li>Refund to Importerr wallet for future purchases</li>
          </ul>
        </section>

        <section className="refund_return_policy">
          <h2>6. Replacement Option</h2>
          <p>
            Where possible, we may provide a <strong>replacement shipment</strong> instead of a refund. Replacements will be dispatched based on stock availability and mutual agreement.
          </p>
        </section>

        <section className="refund_return_policy">
          <h2>7. Contact Us</h2>
          <p>
            For refund-related queries or to raise a claim, please <a href="mailto:contact@importerr.com" style={{ color: 'blue', textDecoration: 'underline' }}>contact@importerr.com</a>
          </p>
        </section>
      </div>
    </div>
  );
}
